import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiContext, API_BASE, handleResponse } from "@/contexts/ApiContext";
import type { UserPreferences } from "@/lib/api";

export function usePreferences() {
  const queryClient = useQueryClient();
  const { fetchWithAuth } = useApiContext();

  const { data, isLoading, error } = useQuery({
    queryKey: ["preferences"],
    queryFn: async () => {
      const response = await fetchWithAuth(`${API_BASE}/preferences`);
      const preferences = await handleResponse<UserPreferences>(response);
      return preferences;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (data: Partial<UserPreferences>) => {
      const response = await fetchWithAuth(`${API_BASE}/preferences`, {
        method: "PUT",
        body: JSON.stringify(data),
      });
      const preferences = await handleResponse<UserPreferences>(response);
      return { preferences };
    },
    onSuccess: (result) => {
      queryClient.setQueryData(["preferences"], result.preferences);
    },
  });

  return {
    preferences: data,
    isLoading,
    error,
    updatePreferences: updateMutation.mutate,
    isUpdating: updateMutation.isPending,
  };
}
